// extracted by mini-css-extract-plugin
export default {"title":"styles_title__6uNcB","pkgContainer":"styles_pkgContainer__Ju6Ss","button":"styles_button__1JnpI"};